import React, { useRef } from "react";
import {
  Paper,
  Typography,
  Button,
  Box,
  Stack,
} from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";

interface Props {
  onFilesSelected: (files: File[]) => void;
}

const ResumeDropzone: React.FC<Props> = ({ onFilesSelected }) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const handleFiles = (files: FileList | null) => {
    if (!files) return;

    const pdfFiles = Array.from(files).filter(
      (file) => file.type === "application/pdf"
    );

    onFilesSelected(pdfFiles);
  };

  const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    handleFiles(e.dataTransfer.files);
  };

  const openFileDialog = () => {
    inputRef.current?.click();
  };

  return (
    <Box display="flex" justifyContent="center" mt={2}>
      <Paper
        elevation={3}
        onDragOver={(e) => e.preventDefault()}
        onDrop={handleDrop}
        sx={{
          width: "100%",
          maxWidth: 520,
          p: 2,
          textAlign: "center",
          border: "2px dashed #c4c4c4",
          borderRadius: 2,
          transition: "0.3s",
          "&:hover": {
            borderColor: "#1976d2",
            boxShadow: 5,
          },
        }}
      >
        <input
          type="file"
          accept="application/pdf"
          multiple
          ref={inputRef}
          onChange={(e) => handleFiles(e.target.files)}
          style={{ display: "none" }}
        />

        <Stack spacing={2} alignItems="center">
          <CloudUploadIcon sx={{ fontSize: 42, color: "#1976d2" }} />

          <Typography variant="h6" fontWeight={600}>
            Drag & Drop resumes here
          </Typography>

          <Typography variant="body2" color="text.secondary">
            Upload one or multiple PDF resumes
          </Typography>

          <Button
            variant="contained"
            size="medium"
            startIcon={<CloudUploadIcon />}
            onClick={openFileDialog}
          >
            Select PDF Files
          </Button>
        </Stack>
      </Paper>
    </Box>
  );
};

export default ResumeDropzone;